async function to<T, U = Error>(promise: Promise<T>) {
  return promise
    .then<[T, null]>(data => [data, null])
    .catch<[undefined, U]>(error => [undefined, error]);
}

export { to };
